import { CapoPlugin } from "/var/lib/jenkins/workspace/mdm.softminds.net/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];